import React from "react";

export default function Footer() {
  return (
    <footer className="flex justify-start p-5 bg-gray-300">
      <div className="flex flex-col items-center">
        <span>Creation & Design:</span>
        <span> Jordan Cruz-Correa</span>
        <span>&copy; 2021</span>
      </div>
    </footer>
  );
}
